import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import {
  useChangeOnlineInvoiceResponsible,
  useGetCustomer,
} from "../../hooks/useCrm";
const initvalue = {
  IdMarketer: null,
  IdOrderOnline: null,
};
export const ResponsibleChangeOnlineInvoiceModal = ({
  show,
  handleClose,
  factorId,
  factorResponsible,
}) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  useEffect(() => {
    setForm({ ...form, IdOrderOnline: factorId });
  }, [factorId]);
  const { mutateAsync: changeResponsible } =
    useChangeOnlineInvoiceResponsible();
  const { data: customerresponsible } = useGetCustomer();
  const customerResponsible = customerresponsible?.data?.Colleague;
  const customerResponsibleOptions = customerResponsible?.map((res) => {
    return {
      value: res.IdUser,
      label: res.FirstName + " " + res.LastName,
    };
  });
  const handleChangeResponsible = async (data) => {
    await changeResponsible(data);
  };
  return (
    <BootstrapModal
      modaltitle="تغییر مسئول"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <SimpleSelect1
            label="لیست مسئولین"
            res={customerResponsibleOptions}
            placeholder={factorResponsible}
            onChange={(e) => {
              setForm({ ...form, IdMarketer: e.value });
            }}
          />
        </div>
        <div className="col-12">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleChangeResponsible(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
